import { newRequest } from "std/api/newRequest";
import type { TApiRelatoriReferencia } from "../pages/referencia";
import type { ApiRelatorioGetParams } from "../types/ApiRelatorioParams";

export function apiRelReferencia({ params }: { params: ApiRelatorioGetParams }): Promise<TApiRelatoriReferencia> {
	return newRequest({
		url: "Relatorio/Referencia",
		type: "get",
		idpk: undefined,
		params,
	});
}
